var csvSeparator = ",";
export var generateCsv = function (columns, data) {
    var headerRow = columns.map(function (c) { return "\"".concat(c.displayName, "\""); }).join(csvSeparator);
    var dataRows = data.map(function (d) {
        return columns.map(function (col) {
            var val = d[col.dataName];
            return "\"".concat(col.formatter ? col.formatter(val) : val, "\"");
        }).join(csvSeparator);
    });
    return headerRow + "\n" + dataRows.join("\n");
};
export var triggerCsvDownload = function (fileName, csvContents, callback) {
    var blob = new Blob([csvContents], { type: 'text/csv;charset=utf-8;' });
    var link = document.createElement('a');
    var url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', "".concat(fileName, ".csv"));
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    callback();
};
